<template>
  <v-container class='input-text-size'>
      <CRUDCriteria :showReset="false" :showSearch="false" :showAdditionalActions="false">
        <template v-slot:criteriaRows>
          <div>
            <v-row dense>
              <v-col cols="3">
               <ClarionDateControl class="input-text-size ma-0 pa-0  mt-2"
                :isToggle="false"
                          :isRequired="false" :isIsoDate="true" v-model="criteriaState.businessdate"
                            @blurred="searchByCriteria"
                          label="Date" />
              </v-col>

              <v-col cols="3"   class="input-text-size mt-4 pt-0 ml-4">
                <SimpleMultiSelect
                id="tax-check-recon-criteria-wkst"
                label="Tax Year"
                :items="criteriaState.taxYear || []"
                :item-list="taxYearList"
                @selected-items="taxYears"
                @blur="searchByCriteria"
              />
            </v-col>

            <v-col cols="3" class="input-text-size mt-n2 pt-0 ml-4">
          <MultiItemSelect
            label="By Tax Districts"
            item-text="taxDistrictCodeAndName"
            item-value="_id"
            :item-list="taxDistrictList"
            :items="criteriaCheck.taxDistricts || []"
            @selected-items="selectedTaxDistricts"
          />
        </v-col>

            </v-row>
          </div>
        </template>
      </CRUDCriteria>

      </v-container>
  </template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
// import { paymentsAuditheaders } from '../paymentutils/PaymentTransactionTableHeaders';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import {
// amountToNumber,
// defaultGridLoading, manageGridLoading,
} from '../../../../util/shared/vue-global';
import { makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import SimpleMultiSelect from '../../../common/base/SimpleMultiSelect.vue';
// import { getWorkstationNumber } from '../../../../util/workstation-util';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';

const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
export default {
  name: 'MonthlyBalanceCriteria',
  data() {
    return {

      sortBy: [
        {
          column: 'paymentNumberAudit',
          direction: 'desc',
        },
      ],
      criteriaStats: {
        allTaxDistricts: false,

      },
      criteriaCheck: {
        taxDistricts: [],
      },

    };
  },
  components: {
    CRUDCriteria,
    ClarionDateControl,
    SimpleMultiSelect,
    MultiItemSelect,
  },
  created() {
    // this.initCriteria();
    this.loadTaxDistricts();
    this.loadTaxYear();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item', 'items',
    ]),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      storeSelItems: (state) => state.tax.taxPayment.selectedItems,

    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },

  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setCriteria']),
    ...mapMutations('tax/taxPayment', [
      'setSelectedItems',
    ]),

    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    postProccessTaxYearData(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        updatedItems.push(items[i]);
      }
      return updatedItems;
    },
    loadTaxYear() {
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
    },

    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },

    taxYears(val) {
      this.criteriaState.taxYear = val;
      this.searchByCriteria();
    },
    selectedTaxDistricts(val) {
      this.criteriaCheck.taxDistricts = val;
      /* update stats */
      this.criteriaStats.allTaxDistricts = (val || []).length === this.taxDistrictList.length;
    },

    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const auditCriteria = { ...returnCriteria };
      this.criteriaState = auditCriteria;
    },
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    async loadTaxDistricts() {
      const criteria = {};
      this.loadTaxDistrict({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        this.criteriaCheck.taxDistricts = this.mapCollectionVal(this.taxDistrictList, '_id');
        /* Set select-all */
        this.criteriaStats.allTaxDistricts = true;
      });
    },
  },

};
</script>
